/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { ISbStoryData } from '@storyblok/react/rsc'
import { useSetAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import { ReactNode, useEffect } from 'react'

import { storyAtom } from '@/store/story'

/** A description of the available properties for this component. */
type StoryblokStateProviderProps = {
  /** The Storyblok story data. */
  story: ISbStoryData

  /** The children of the component. */
  children: ReactNode
}

/**
 * Provides the Storyblok story data to the application. This component should be used at the root of the
 * page to ensure that the initial story data is available to all child components.
 */
const StoryblokStoryProvider = ({ story, children }: StoryblokStateProviderProps) => {
  useHydrateAtoms([[storyAtom, story]])
  const setStory = useSetAtom(storyAtom)

  /**
   * Update the story atom when the story changes (as a result of client side navigation or other changes).
   */
  useEffect(() => {
    setStory(story)
  }, [story, setStory])

  return children
}

export { StoryblokStoryProvider }
